import { ProfessionalTypeEnum } from '@gql/graphql';
import type { BookingPageFormValues, BookingPageProps } from '@presentation/pages';
import { useTranslation } from '@presentation/utils';
import { useFormikContext } from 'formik';
import { capitalize } from 'lodash/fp';
import type { FC } from 'react';
import { FaClock, FaMapMarkerAlt } from 'react-icons/fa';
import * as Styled from '../styled';

export const BookingPageRecap: FC<BookingPageProps> = (props) => {
  const { pro } = props;
  const { values } = useFormikContext<BookingPageFormValues>();
  const { translate } = useTranslation();

  // TC-1405
  const shouldHideAddress = pro.id === 3265;

  return (
    <Styled.RecapContainer>
      <Styled.RecapTitle>{translate('booking.summary.title')}</Styled.RecapTitle>
      <Styled.WarningLabel>{translate('booking.summary.warning')}</Styled.WarningLabel>
      <Styled.RecapCardDateTitle>
        {capitalize(values?.bookingStart?.format('dddd DD MMMM YYYY • HH:mm') ?? '')}
      </Styled.RecapCardDateTitle>
      <Styled.Label>{translate('booking.summary.service')}</Styled.Label>
      <Styled.Value>
        {pro.service}
        <Styled.ValueLineBreak />
        <Styled.InfoIconWrapper>
          <FaClock />
        </Styled.InfoIconWrapper>
        {pro.serviceDuration}min
      </Styled.Value>
      <Styled.Label>
        {translate(`glossary.${pro.type === ProfessionalTypeEnum.GROOMER ? 'groomer' : 'vet'}`)}
      </Styled.Label>
      <Styled.Value>{pro.workerName}</Styled.Value>
      {pro.servicePrice && (
        <>
          <Styled.Label>{translate('glossary.price')}</Styled.Label>
          <Styled.Value>{pro.servicePrice}</Styled.Value>
        </>
      )}
      <Styled.RecapProfileWrapper>
        {pro.image && <Styled.RecapProfileImg src={pro.image} />}
        <span>
          <div>{pro.title}</div>

          {!shouldHideAddress ? (
            <>
              <Styled.InfoIconWrapper>
                <FaMapMarkerAlt />
              </Styled.InfoIconWrapper>
              {pro.address}
            </>
          ) : null}
        </span>
      </Styled.RecapProfileWrapper>
    </Styled.RecapContainer>
  );
};
